import { toDate as e } from "./toDate.js";
function i(t) {
  return e(t).getTime();
}
export {
  i as default,
  i as getTime
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getTime.js
// module id = 248
// module chunks = 67